import { CONSUMER_MANAGE_WORKFLOWS_URL, CP_QP_ORC_MANAGE_WORKFLOWS_URL, IN_REVIEW_URL, ORC_MANAGE_WORKFLOWS_URL } from './../constants/constant';
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreService } from 'src/app/core/services/core.service';
import { ManageWorkflowService } from 'src/app/modules/manage-workflows/services/manage-workflow.service';
import { ToasterNotificationService } from '../components/toaster-notification/toaster-notification.service';
import { WorkflowTableGridHeader } from '../components/workflow-table-grid/workflow-table-grid.model';
import { CP_QP_MANAGE_WORKFLOWS_URL, CP_QP_REPORT_ACTION_URL, ENDORSER_MANAGE_WORKFLOWS_URL, MANAGE_WORKFLOWS_URL, NOTIFICATION_ERROR, NOTIFICATION_SUCCESS, NOTIFICATION_WARNING } from '../constants/constant';
import { ALLOWED_FORMAT, CP_QP_REPORT_DELETED, CP_QP_REPORT_FORMAT, DOCUMENT_FILE_SIZE, DUPLICATE_FILE_ERROR, ERROR_OCCURED_TRY_AGAIN_LATER, FILE_SIZE_ERROR, FILL_ALL_MANDATORY_FIELDS, NO_RECORD_FOUND, PRINTER_PROOF_DELETED, SOMETHING_WENT_WRONG } from '../constants/messages';
import { DataCaptureHeader } from '../models/dataCapture.model';
import { PrinterProofFileUploadDetails } from '../models/manageWorkflow.model';
import { NotificationAlert } from '../models/notificationAlert.model';
import { UserDetail, UserFileDownload } from '../models/userDetail.model';
import { base64ToArrayBuffer, checkForSameFile, saveByteArray } from '../utilities/util';
import { TextValidator } from '../validators/textPatternValidator';

@Component({
  selector: 'app-cp-qp-report',
  templateUrl: './cp-qp-report.component.html',
  styleUrls: ['./cp-qp-report.component.scss']
})
export class CpQpReportComponent implements OnInit {
  public showSubmittedPrinterProofPopUp: boolean;
  public cpqpReportForm: FormGroup;
  public submittedcpqpReportForm = false;
  public CpQpReportData: PrinterProofFileUploadDetails[] = [];
  public alert: NotificationAlert;
  public formFileValue: File;
  public DASHBOARD_URL;
  public selectedDelDocument;
  public showDeletePopup = false;
  public popupMessage: string;
  public loginID: number;
  public header: DataCaptureHeader;
  public workflowID: string;
  public yearCode: string;
  public showUnsavedPopup = false;
  public showLoader = false;
  public cpQpReportHeaders: WorkflowTableGridHeader[];
  public isAdmin = false;
  public isEndorser = false;
  public isCPQP = false;
  public isORC = false;
  public isConsumer = false;
 // public commentControl = new FormControl(null, [Validators.required, TextValidator(300)]);
  public acknowledgeCheckbox = new FormControl(null);
  public showRejectedPopup = false;
  public submitCommentForm = false;
  public showApprovedPopup = false;
  public isReportingCycleLocked = false;
  public isCompleteWorkflow = false;
  showComments: boolean;
  alerts: any = [];
  comments: any = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private manageWorkflow: ManageWorkflowService,
    private coreService: CoreService,
    private toasterNotificationService: ToasterNotificationService,
    private datePipe: DatePipe) { }

  ngOnInit(): void {
    const seperatorURL = `/${CP_QP_REPORT_ACTION_URL}`;
    this.isReportingCycleLocked = sessionStorage.getItem('isCurrentReportingCycleYearLock') === '1';
    this.DASHBOARD_URL = this.router.url.substr(1, this.router.url.indexOf(seperatorURL)).slice(0, -1);
    if (this.router.url.indexOf(ENDORSER_MANAGE_WORKFLOWS_URL) > -1) {
      this.isEndorser = true;
    } else if (this.router.url.indexOf(CP_QP_MANAGE_WORKFLOWS_URL) > -1) {
      this.isCPQP = true;
    } else if (this.router.url.indexOf(CP_QP_ORC_MANAGE_WORKFLOWS_URL) > -1) {
      if (this.router.url.indexOf(IN_REVIEW_URL) > -1) {
        this.isORC = true;
      } else {
        this.isCPQP = true;
      }
    } else if (this.router.url.indexOf(ORC_MANAGE_WORKFLOWS_URL) > -1) {
      this.isORC = true;
    } else if (this.router.url.indexOf(CONSUMER_MANAGE_WORKFLOWS_URL) > -1) {
      this.isConsumer = true;
    } else if (this.router.url.indexOf(MANAGE_WORKFLOWS_URL) > -1) {
      this.isAdmin = true;
    }

    if (this.route && this.route.params) {
      this.route.params.subscribe((params) => {
        if (params.workflowID && params.yearCode) {
          this.yearCode = params.yearCode;
          this.workflowID = params.workflowID;
          this.showLoader =true;
          let tabStatus = 1;
          if(this.isEndorser || this.isORC ) {
            tabStatus = 2;
          }
          // this.manageWorkflow
          //   .getWorkflowDetails(this.workflowID ,tabStatus)
          //   .subscribe((response) => {
          //     this.header = response;
          //   });
          this.getCpQpReportData(this.workflowID, this.yearCode);
        }
      });
    }
    // this.cpqpReportForm = this.getcpqpReportFormControls();
  }

/**
 *@description get CP/QP Report data
 *
 * @private
 * @param {string} workflowID
 * @param {string} yearCode
 * @memberof CpQpReportComponent
 */
private getCpQpReportData(workflowID: string, yearCode: string): void {
    this.showLoader = true;
    this.manageWorkflow
      .getPrinterProofFilesData(workflowID, yearCode)
      .subscribe(
        (response) => {
          const data = response.value;
          this.header = data.headerDetails && data.headerDetails.length && data.headerDetails[0];
          //this.alerts = this.getAllAlerts(data.printerProofUserList);
          //this.comments = this.getAllComments(data.printerProofCommentsList);
          this.cpqpReportForm = this.getcpqpReportFormControls();
          this.cpQpReportHeaders = this.getCpQpReportHeaders();
          if (data && data.cpqpReportList.length) {
            this.CpQpReportData = data.cpqpReportList;
            this.CpQpReportData.forEach(report => {
              report.isAdmin = this.isAdmin;
              if (this.isAdmin) {
                report.canEditReport = true;
              }
            })
          }
          else{
            this.CpQpReportData = [];
          }
          this.showLoader = false;
          
        },
        (error) => {
          this.alert = {
            type: NOTIFICATION_ERROR,
            message: SOMETHING_WENT_WRONG,
          };
          this.showLoader = false;
        }
      );
  }


/**
 *@description submit cp/qp report form
 *
 * @memberof CpQpReportComponent
 */
public submitcpqpReportForm(): void {
    this.submittedcpqpReportForm = true;
    this.alert = null;
    const cpqpReportFormData = this.cpqpReportForm.getRawValue();
    cpqpReportFormData.isActive = '1';
    cpqpReportFormData.IsPrinterProof = '0';
    cpqpReportFormData.fileTypeCode = '-1';
    cpqpReportFormData.documentComment = '-1';
    if (this.cpqpReportForm.valid) {
      if (checkForSameFile(this.CpQpReportData, this.formFileValue)) {
        this.showLoader = true;
        this.submittedcpqpReportForm = false;
        const fileVal = new FormData();
        fileVal.append('wfID', this.workflowID);
        fileVal.append('fileTypeCode', cpqpReportFormData.fileTypeCode);
        fileVal.append('fileName', this.formFileValue.name);
        fileVal.append('filePath', this.formFileValue);
        fileVal.append('description', cpqpReportFormData.description);
        fileVal.append('fileUploadStatusCode', '-1');
        fileVal.append('documentComment', cpqpReportFormData.documentComment);
        fileVal.append('IsPrinterProof', cpqpReportFormData.IsPrinterProof);
        fileVal.append('IsActive', cpqpReportFormData.isActive);
        fileVal.append('yearCode', this.yearCode);
        fileVal.append('loginID', this.coreService.getLoggedInID().toString());
        this.manageWorkflow
          .postPrinterProofFilesData(fileVal)
          .subscribe((resolve) => {
            this.cpqpReportForm = this.getcpqpReportFormControls();
            this.getCpQpReportData(this.workflowID, this.yearCode);
            this.toasterNotificationService.showSuccessNotification('Document has been successfully uploaded');
          }, (error) => {
            this.showLoader = false;
            this.toasterNotificationService.showErrorNotification('Your data entry has not been submitted for review.');
          });
      } else {
        this.alert = {
          type: NOTIFICATION_ERROR,
          message: `${DUPLICATE_FILE_ERROR}`,
        };
      }
    } else {
      this.alert = {
        type: NOTIFICATION_ERROR,
        message: `${FILL_ALL_MANDATORY_FIELDS}`,
      };
    }
  }

  /**
   *@description Validate file based on type and size
   *
   * @param {*} event
   * @memberof CpQpReportComponent
   */
  public selectFile(event): void {
    this.formFileValue = event;
    this.alert = null;
    const fileExt = this.formFileValue.name.split('.');
    if (
      !(fileExt[fileExt.length - 1].toLocaleLowerCase() === 'pdf'
      || fileExt[fileExt.length-1].toLocaleLowerCase() === 'docx'
      || fileExt[fileExt.length-1].toLocaleLowerCase() === 'xls'
      || fileExt[fileExt.length-1].toLocaleLowerCase() === 'xlsx'
      || fileExt[fileExt.length-1].toLocaleLowerCase() === 'jpeg'
      || fileExt[fileExt.length-1].toLocaleLowerCase() === 'jpg'
      || fileExt[fileExt.length-1].toLocaleLowerCase() === 'gif'
      || fileExt[fileExt.length-1].toLocaleLowerCase() === 'zip'
      || fileExt[fileExt.length-1].toLocaleLowerCase() === 'rar'
      || fileExt[fileExt.length-1].toLocaleLowerCase() === 'txt'
      || fileExt[fileExt.length-1].toLocaleLowerCase() === 'doc')
    ) {
      this.alert = {
        type: NOTIFICATION_ERROR,
        message: `${CP_QP_REPORT_FORMAT}`,
      };
      this.cpqpReportForm.controls.file.setValue(null);
    }
    if (this.formFileValue && this.formFileValue.size && this.formFileValue.size/1024/1024 > 100) {
      this.alert = {
        type: NOTIFICATION_ERROR,
        message: `${FILE_SIZE_ERROR}`,
      };
      this.cpqpReportForm.controls.file.setValue(null);
    }
    if (fileExt[0] && fileExt[0].length > 100) {
      this.alert = {
        type: NOTIFICATION_ERROR,
        message: `${DOCUMENT_FILE_SIZE}`,
      };
      this.cpqpReportForm.controls.file.setValue(null);
    }
  }

/**
 * @description close Delete popup
 *
 * @memberof CpQpReportComponent
 */
public closeDeletePopup(): void {
    this.showDeletePopup = false;
}

/**
 * @description Delete selected uploaded document
 *
 * @memberof CpQpReportComponent
 */
public onDeleteUploadedDocument(): void {
    this.showLoader = true;
    this.showDeletePopup = false;
    this.selectedDelDocument.isActive = '0';
    const fileVal = new FormData();
    fileVal.append('isActive', this.selectedDelDocument.isActive);
    this.manageWorkflow
      .updatePrinterProofData(fileVal, this.selectedDelDocument.id)
      .subscribe(
        (response) => {
          if (response) {
            this.showLoader = false;
            this.alert = {
              type: NOTIFICATION_SUCCESS,
              message: `${CP_QP_REPORT_DELETED}`,
            };
          }
          this.submittedcpqpReportForm = false;
          this.getCpQpReportData(this.workflowID, this.yearCode);
        },
        (error) => {
          this.alert = {
            type: NOTIFICATION_ERROR,
            message: `${ERROR_OCCURED_TRY_AGAIN_LATER}`,
          };
        }
      );
  }

/**
 * @description Download uploaded file
 *
 * @param {PrinterProofFileUploadDetails} userFile
 * @memberof CpQpReportComponent
 */
public downloadFile(userFile: PrinterProofFileUploadDetails): void {
    this.manageWorkflow.getPrinterProofDownload(userFile.id).subscribe(
      (response: UserFileDownload) => {
        const sampleBytes = base64ToArrayBuffer(response.fileContents);
        saveByteArray([sampleBytes], response.fileDownloadName);
      },
      (error) => {
        this.alert = {
          type: NOTIFICATION_ERROR,
          message: `${ERROR_OCCURED_TRY_AGAIN_LATER}`,
        };
      }
    );
  }

/**
 * @description On clicking of delete uploaded document and show delete popup
 *
 * @param {PrinterProofFileUploadDetails} CpQpReportData
 * @memberof CpQpReportComponent
 */
public onFileUploadDataDelete(
    CpQpReportData: PrinterProofFileUploadDetails
  ): void {
    const documentName = CpQpReportData.fileName;
    this.selectedDelDocument = CpQpReportData;
    this.showDeletePopup = true;
    this.popupMessage = `Once you delete the ${documentName} document it cannot be recovered. Would you like to continue?`;
  }

  /**
   * @description Navigate back to workflows
   *
   * @memberof CpQpReportComponent
   */
  public onBackToWorkFlow(): void {
    if (this.router.url) {
      this.router.navigateByUrl(
        this.router.url.substr(1, this.router.url.indexOf('/user')).slice(0, -1)
      );
    }
  }

  /**
   * @description Show CP/QP Report Upload document form
   *
   * @param {UserDetail} [user]
   * @return {*}  {FormGroup}
   * @memberof CpQpReportComponent
   */
  public getcpqpReportFormControls(user?: UserDetail): FormGroup {
    var disableStatus = !(this.header.workflowStatus === '11' || this.header.workflowStatus === '8');
    if (this.isAdmin) {
      disableStatus = false;
    }
    return new FormGroup({
      file: new FormControl({value: null , disabled: disableStatus}, [Validators.required]),
      isPrimary: new FormControl(null),
      isActive: new FormControl('1'),
      description: new FormControl({value: null , disabled: disableStatus}, [Validators.required, TextValidator(100)]),
    });
  }

/**
 * @description Get CP/QP uploaded document headers
 *
 * @return {*}  {WorkflowTableGridHeader[]}
 * @memberof CpQpReportComponent
 */
  public getCpQpReportHeaders(): WorkflowTableGridHeader[] {
    let headers = [
      {
        name: 'Document Name',
        key: 'fileName',
        sortType: 'string',
        type: 'link-searchName',
      },
      {
        name: 'Uploaded by',
        key: 'uploadedBy',
        sortType: 'string',
        type: 'string',
      },
      {
        name: 'Description',
        key: 'description',
        sortType: 'string',
        type: 'string',
      },
      { name: 'Date', key: 'uploadDate', type: 'date' }
    ];
    if ( this.isAdmin || this.isCPQP) {
      if (this.header.workflowStatus === '7') {
        this.isCompleteWorkflow = true;
        if (this.isAdmin) {
          headers.push({ name: '', key: '', type: 'delete-download-button' });
        } else {
          headers.push({ name: '', key: '', type: 'download-button' });
        }        
      } else {
        if ((this.isCPQP && this.header.workflowStatus === '11') ||
            (this.isAdmin)) {
          headers.push({ name: '', key: '', type: 'delete-download-button' });
        } else {
          headers.push({ name: '', key: '', type: 'download-button' });
        }
      }
    } else if (this.isEndorser || this.isConsumer) {
      headers.push({ name: '', key: '', type: 'download-button' });
    }
    return headers;
  }

  /**
   * @description Navigate back to workflows
   *
   * @memberof CpQpReportComponent
   */
  public BacktoManageWorkflow(): void {
    this.router.navigateByUrl(this.DASHBOARD_URL);
  }

  public finalSubmitForReview(): void {
    this.showLoader = true;
    const data = {
      yearCode: this.yearCode,
      workflowID: this.workflowID,
      loginID: this.coreService.getLoggedInID(),
    };
    this.manageWorkflow.checkConsentToPublishWorkflow(this.workflowID, this.yearCode).subscribe((checkStatus)=> {
      if (checkStatus.value.statusCode === 200) {
        this.manageWorkflow.submitForReview(data).subscribe((resolve) => {
          this.showLoader = false;
          this.toasterNotificationService.showSuccessNotification('Your report has been submitted.');
          this.getCpQpReportData(this.workflowID, this.yearCode);
        }, (error) => {
          this.showLoader = false;
          this.toasterNotificationService.showErrorNotification('Your report has not been submitted.');
        });
      } else if (checkStatus.value.statusCode === 1001) {
        this.showLoader = false;
        this.header.isSubmitter = '0';
        this.toasterNotificationService.showWarningNotification(`${checkStatus.value.message}`);
      }
    }, (error) => {
      this.showLoader = false;
      this.toasterNotificationService.showErrorNotification('Your report has not been submitted.');
    });
  }

  public checkConsnetToPublishWorkflowSubmitted(): void {
    this.showLoader
  }

}


